// HEIC/HEIF handling for the file previews (DEV-3002).
//
// These previews used to call heic2any, which bundles a 2019-era libheif that throws
// "ERR_LIBHEIF format not supported" on the HEICs recent iPhones produce -- the ones carrying a
// `tmap` tone-map/gain-map image (iOS 18 HDR photos). heic2any cannot be upgraded; 0.0.4 is its
// newest version. heic-to wraps libheif 1.19, which decodes them.

// ISO-BMFF puts "ftyp" at offset 4 followed by the major brand; these are the HEIF brands no
// browser can render. avif is deliberately absent -- browsers decode that natively.
const HEIF_BRANDS = ["heic", "heix", "hevc", "hevx", "heim", "heis", "hevm", "hevs", "mif1", "msf1", "heif"];

// Sniffing the header rather than the file name covers keys whose extension is upper-case (an
// iPhone yields IMG_0001.HEIC) or simply wrong, and keeps the decoder chunk from being fetched
// for the jpg/png previews that make up most of a job.
export async function looksLikeHeic(blob) {
	const header = new Uint8Array(await blob.slice(0, 12).arrayBuffer());
	const ascii = String.fromCharCode(...header);
	return ascii.slice(4, 8) === "ftyp" && HEIF_BRANDS.includes(ascii.slice(8, 12));
}

// Returns something an <img> can display: the blob itself, or a JPEG rendering of it when the
// bytes turn out to be HEIC. Throws if a HEIC cannot be decoded, so callers can show an error
// rather than an empty frame.
export async function toDisplayableImage(blob) {
	if (!await looksLikeHeic(blob)) {
		return blob;
	}

	// heic-to is ~2.9MB of libheif, so it is code-split out and fetched only when a HEIC is
	// actually opened.
	const {heicTo} = await import("heic-to");
	return await heicTo({blob, type: "image/jpeg", quality: 0.9});
}
